import React from "react";
import { Text } from "../../Type";

import styles from "./index.module.css";

interface TooltipUiProps {
  /** Tooltip text */
  label: string;
}

/**
 * This is the presentational `TooltipUi` element. See `Tooltip` for the implementation.
 */
const TooltipUi: React.FC<TooltipUiProps> = ({ label, ...rest }) => {
  return (
    <div className={styles.root} {...rest}>
      <Text size="x-sm" theme="inverse" className={styles.customLineHeight}>
        {label}
      </Text>
    </div>
  );
};

export default TooltipUi;
